import request from 'utils/request'

/*---------  角色管理    -------*/
//获取业务列表
export const getBusinessList = () => request().get('business/list')

//获取table数据
export const getTableData = data => request().post('creditHistory/page', data)
//获取权限级别
export const getRegionList = data =>
  request().post('business/region/list', data)
//导出
export const exportCreditHistory = companyCode =>
  request().get(`creditHistory/export/${companyCode}`, { responseType: 'blob' })
//查询companyCode 和 permissions
export const getOverview = id => request().get(`customer/overview/${id}`)
//调整
export const creditReduce = data => request().post('creditHistory/reduce', data)
//查询调减
export const pageReduced = data =>
  request().post('creditHistory/pageReduced', data)
